__turbopack_context__.v({
  "actionBar": "iAkGFG_actionBar",
  "amountInputSection": "iAkGFG_amountInputSection",
  "amountInputSectionPadBottom": "iAkGFG_amountInputSectionPadBottom",
  "infoParagraph": "iAkGFG_infoParagraph",
  "shareContainer": "iAkGFG_shareContainer",
  "shareInputContainer": "iAkGFG_shareInputContainer",
  "shareLink": "iAkGFG_shareLink",
  "shareSelectionSpacer": "iAkGFG_shareSelectionSpacer",
  "shareSelectionWrapper": "iAkGFG_shareSelectionWrapper",
  "sharesSelectorContainer": "iAkGFG_sharesSelectorContainer",
  "showAllOrganizationsLink": "iAkGFG_showAllOrganizationsLink",
  "sumButtonsWrapper": "iAkGFG_sumButtonsWrapper",
  "sumWrapper": "iAkGFG_sumWrapper",
});
